import React, { useEffect, useMemo, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    ButtonGroup,
    Card,
    CardContent,
    CardHeader,
    Typography,
    Button,
    Tooltip,
    IconButton,
    Alert,
    Divider,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Stack,
    Box,
    Menu,
    CircularProgress,
    Autocomplete,
    TextField,
    Grid,
    TableRow,
    Paper,
    InputBase,
    Checkbox,
    FormControlLabel,
    Switch,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead
} from '@mui/material'
import {
    ErrorOutline as AlertCircleIcon,
    ArrowBack as ArrowLeftIcon,
    CheckCircleOutline as CheckCircle2Icon,
    ExpandMore as ChevronDown,
    ContentPaste as Clipboard,
    Download as Download,
    AssignmentTurnedIn as FileCheck2,
    Settings as FileCog,
    FindInPage as FileScan,
    Refresh as Loader2,
    AttachFile as PaperclipIcon,
    WarningAmber as TriangleAlert,
    Apartment as BuildingIcon,
    Badge as IDIcon,
    Receipt as BillIcon,
    FactCheck as StatusIcon,
    CloudQueue as ModeIcon,
    Timer as TimeIcon,
    Tag as HashIcon,
    History
} from '@mui/icons-material'
import { Get_Val_By_ServiceKey } from '../../globalhelper/DynamicFormHelpers'
import { postRequest, getRequest } from '../../globalhelper/helper'
import { useApiMutation, useApiQuery } from '../../lib/query/hooks'
import { setOneSidePDFKey } from '../../redux/DynamicForms/dynamicFormsActions'
import PopoverComponent from '../../components/popover/popover'
import { useDynamicOption, useChangeValByserviceID, useOnChangeOperation } from '../../hooks/dynamicform.hooks'
import { showAlert } from '../../redux/Common/commonActions'
import LinearProgress from '@mui/material/LinearProgress';
import ValidatePopUp from '../VR2_Form_Rendering/ValidatePopup'
import Popup from '../../components/SimplePOPUP'
import DialougeBox from '../VR2_Form_Rendering/DialougeBox'

const base64ToBlob = (base64, mime) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mime });
};

const DocumentHeader = ({ HeaderJson = [], title, options, onOpenChange, screenName, onValidate_Document, formProgress, onSubmit_Document, onBack, setConfirmationDialog }) => {
    const dispatch = useDispatch()
    const [headerValidationError, setHeaderValidationError] = useState({})
    let [messageElements, setMessageElements] = useState([])

    const [validateAnchorEl, setValidateAnchorEl] = useState(null);
    const openValidateMenu = Boolean(validateAnchorEl);
    const [selectedAction, setSelectedAction] = useState("Validate");

    const [submitAnchorEl, setSubmitAnchorEl] = useState(null);
    const openSubmitMenu = Boolean(submitAnchorEl);
    const [selectedSubmitAction, setSelectedSubmitAction] = useState("Activate");

    const [validationSummary, setValidationSummary] = useState([]);
    const [openValidationSummary, setOpenValidationSummary] = useState(false);

    const [autoSaveInterval, setAutoSaveInterval] = useState(null);
    const [autoSaveAnchorEl, setAutoSaveAnchorEl] = useState(null);
    const openAutoSaveMenu = Boolean(autoSaveAnchorEl);
    const [AuditLog, setAuditLog] = useState([])
    const [openAuditLog, setOpenAuditLog] = useState(false);
    const [isAuditLogLoading, setIsAuditLogLoading] = useState(false);
    const [auditFilterField, setAuditFilterField] = useState(null);
    const [auditFilterDate, setAuditFilterDate] = useState("");
    const [auditFilterTime, setAuditFilterTime] = useState("");

    const allAuditLogs = useMemo(() => {
        let flat = [];
        if (AuditLog?.length > 0) {
            AuditLog.forEach(group => {
                Object.values(group).forEach(log => {
                    flat.push(log);
                });
            });
        }
        return flat;
    }, [AuditLog]);

    const uniqueAuditFields = useMemo(() => {
        return [...new Set(allAuditLogs.map(log => log.serviceKey))].filter(Boolean);
    }, [allAuditLogs]);

    const filteredAuditLogs = useMemo(() => {
        return allAuditLogs.filter(log => {
            let matchesField = true;
            let matchesDate = true;
            let matchesTime = true;
            if (auditFilterField) {
                matchesField = log.serviceKey === auditFilterField;
            }
            if (auditFilterDate) {
                const [year, month, day] = auditFilterDate.split('-');
                const formatted = `${day}-${month}-${year}`;
                matchesDate = log.DateTime?.includes(formatted);
            }
            if (auditFilterTime) {
                matchesTime = log.DateTime?.includes(auditFilterTime);
            }
            return matchesField && matchesDate && matchesTime;
        });
    }, [allAuditLogs, auditFilterField, auditFilterDate, auditFilterTime]);

    const [showpopup, setShowpopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState(null);
    const [popupTable, setPopupTable] = useState(false);
    const [tokenState, setTokenState] = useState({});
    const [expAnchorEl, setExpAnchorEl] = useState(null);
    const [askReason, setAskReason] = useState(false);

    useEffect(() => {
        let intervalId;
        if (autoSaveInterval) {
            const timeInMs = parseFloat(autoSaveInterval) * 60 * 1000;
            intervalId = setInterval(() => {
                console.log(`Auto saving document every ${autoSaveInterval} minute(s)`);
                onValidate_Document?.(true, false, true);
            }, timeInMs);
        }
        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [autoSaveInterval, onValidate_Document]);

    const handleReExtract = async () => {
        try {
            postRequest(
                "api/edureka/handleReExtraction",
                {
                    item: JSON.parse(localStorage.getItem("selectedItem")),
                    orgid: Get_Val_By_ServiceKey('Organization ID', DocForm_Json) || orgid,
                    orgname: Get_Val_By_ServiceKey('Organization Name', DocForm_Json) || localStorage.getItem("orgName"),
                },
                1000000,
            );
            setShowpopup(null);
            onOpenChange?.(false);
            onBack?.();
        } catch (error) {
            console.log(error);
        } finally {
            localStorage.removeItem("selectedItem");
            localStorage.removeItem("OrgName");
        }
    };

    const getAuditlog = async () => {
        try {
            setIsAuditLogLoading(true);
            let { res } = await getRequest(`api/vr2/getAuditlog?orgid=${orgid || 'NoLDE'}&screenName=${screenName}&documentNo=${Get_Val_By_ServiceKey(screenName === "PurchaseOrder" ? "PO Number" : screenName === "GoodsAndServicesEntries" ? "GRN/SRN Number" : screenName === "ItemMaster" ? "Item ID" : screenName === "VendorMaster" ? "Vendor ID" : screenName === "OrganizationMaster" ? "Organization ID" : screenName === "BillExtract" ? "Bill Number" : '', DocForm_Json) || screenName || 'Untitled Document'}`)

            // Backend could return the array directly or in a 'log' wrapper
            let logData = res?.data?.log || res?.data || res || [];
            if (!Array.isArray(logData) && Array.isArray(logData?.data)) {
                logData = logData.data;
            }

            console.log("Audit log data:", logData)
            setAuditLog(Array.isArray(logData) ? logData : [])
            setOpenAuditLog(true)
        } catch (error) {
            console.log(error);
        } finally {
            setIsAuditLogLoading(false);
        }
    }

    const ifReject = useCallback(() => {
        setAskReason({ enable: true, val: "" });
    }, []);

    const handleAction = async (actionName = selectedAction) => {
        if (actionName === "Validate") {

            const response = await onValidate_Document?.(false);

            if (
                response?.status === "error" ||
                response?.res?.status === "error"
            ) {

                setValidationSummary([
                    response?.message ||
                    response?.res?.message ||
                    "Validation Failed"
                ]);

                setOpenValidationSummary(true);
            }
        }

        if (actionName === "Validate & Save") {
            console.log("Validate & Save");
            await onValidate_Document?.(true);
        }

        if (actionName === "Validate & Exit") {
            console.log("Validate & Exit");
            await onValidate_Document?.(true, true);
            // onValidate_Document?.(true);
            setTimeout(() => {
                onBack?.();
            }, 500);
        }
    };

    const handleValidateMenuClose = () => {
        setValidateAnchorEl(null);
    };
    // Selectors from legacy state
    const DocForm_Json = useSelector(state => state.dynamicForms.DOCJSON || [])
    const dynamicOption_Done = useSelector(state => state.dynamicForms.dynamicOption_Done || {})
    useEffect(() => {
        setAutoSaveInterval(Get_Val_By_ServiceKey('Status', DocForm_Json) == "Not Released" ? DocForm_Json.length > 0 && screenName === 'BillExtract' ? '0.5' : (screenName === 'ItemPreferences' || screenName === 'VendorPreferences') && DocForm_Json.length > 0 ? null : DocForm_Json.length > 0 ? '5' : null : null);
    }, [screenName, DocForm_Json]);
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);
    const handleClickMenu = (event) => setAnchorEl(event.currentTarget);
    const handleCloseMenu = () => setAnchorEl(null);

    const reduxOrgId = useSelector(state => state.VR2.orgIdConst || "");
    let interimId = useMemo(() => Get_Val_By_ServiceKey("Interim ID", DocForm_Json), [DocForm_Json]);
    let orgid = useMemo(() => Get_Val_By_ServiceKey("Organization ID", DocForm_Json), [DocForm_Json]) || reduxOrgId;
    orgid = useMemo(() => Get_Val_By_ServiceKey("Receiver ID", DocForm_Json), [DocForm_Json]) || orgid
    let { mutate: validatePopup, data: ExtractionReviewResponse } = useApiMutation(`api/vr2/validatePopup?interimId=${interimId}&orgid=${orgid}`, "post")
    let ExtractionReview = ExtractionReviewResponse?.res?.data;

    useEffect(() => {
        if (interimId && orgid) {
            console.log("here", interimId, orgid);
            validatePopup();
        }
    }, [interimId, orgid]);

    let onChangeOperation = useOnChangeOperation()
    let fetchDynamicOptions = useDynamicOption()
    const changeValByserviceID = useChangeValByserviceID();

    const handleOpenPDF = (e, item) => {
        e?.preventDefault();
        dispatch(setOneSidePDFKey({ PDF_KEY: "", FILE_TYPE: "" }));

        postRequest(`api/vr2/getPDF_file`, {
            key: item?.val,
        }).then((res) => {
            if (res.res.status === "success") {
                const base64Data = res.res.data;
                dispatch(setOneSidePDFKey({
                    PDF_KEY: base64Data,
                    FILE_TYPE: item?.val.split(".").at(-1),
                }));
                onOpenChange?.(true);
            }
        });
    };

    const handleExtractionReview = (customData) => {
        let messages = []
        let msgObj = null;

        if (customData) {
            msgObj = typeof customData === 'string' ? { success: customData } : customData;
        } else {
            let reviewData = typeof ExtractionReview === 'string' ? JSON.parse(ExtractionReview) : ExtractionReview;
            msgObj = reviewData?.message;
        }

        if (Array.isArray(msgObj?.success)) {
            msgObj?.success?.forEach((msg) => messages.push({ type: 'success', text: msg }));
        } else if (msgObj?.success) {
            messages.push({ type: 'success', text: msgObj?.success });
        }

        if (Array.isArray(msgObj?.error)) {
            msgObj?.error?.forEach((msg) => messages.push({ type: 'error', text: msg }));
        } else if (msgObj?.error) {
            messages.push({ type: 'error', text: msgObj?.error });
        }

        if (Array.isArray(msgObj?.warning)) {
            msgObj?.warning?.forEach((msg) => messages.push({ type: 'warning', text: msg }));
        } else if (msgObj?.warning) {
            messages.push({ type: 'warning', text: msgObj?.warning });
        }

        if (messages.length > 0) {
            return messages;
        }

        if (typeof msgObj === 'string') {
            return [{ type: 'info', text: msgObj }];
        }

        return [{ type: "error", text: "No message found" }]
    }

    const dynamoOption_fn = useCallback(() => {
        DocForm_Json?.forEach((rowNode) => {
            rowNode.children?.forEach((sectionNode) => {
                sectionNode.children?.forEach((childrenNode) => {
                    if (childrenNode.render === "true") {
                        if (
                            childrenNode?.dynamic_option &&
                            childrenNode?.dynamic_option?.api_Directory
                        ) {
                            const doneKey = `${childrenNode?.serviceKey}$${childrenNode?.serviceID} `;
                            if (dynamicOption_Done[doneKey] === undefined) {
                                fetchDynamicOptions(childrenNode, doneKey);
                            }
                        }
                    }
                })
            })
        })
    }, [DocForm_Json, fetchDynamicOptions, dynamicOption_Done]);

    const handleValidatePopup = async (Status) => {
        try {
            const orgidVal = orgid || Get_Val_By_ServiceKey("Organization ID", DocForm_Json);
            if (popupMessage === null) {
                let response = await postRequest(
                    `api/vr2/validatePopup?interimId=${interimId}&orgid=${orgidVal}&Status=${Status} `,
                );
                if (response && response.res?.data?.message) {
                    const message = response.res.data.message;
                    setPopupMessage(message);
                    setShowpopup(true);
                }
            } else {
                setShowpopup(true);
            }
        } catch (error) {
            console.error("API request failed:", error);
        }
    };

    const handle3WayMatchingPopup = async () => {
        try {
            const orgidVal = orgid || Get_Val_By_ServiceKey("Organization ID", DocForm_Json);
            let response = await getRequest(
                `api/vr2/ThreeWayMatching ? interimId = ${interimId}& orgid=${orgidVal} `,
            );
            if (response && response.res?.data) {
                const DATA = response.res.data;
                setPopupTable({
                    search: "",
                    data: DATA,
                    filteredData: DATA,
                    header: DATA.length ? Object.keys(DATA[0]) : [],
                });
            }
        } catch (error) {
            console.error("API request failed:", error);
        }
    };

    const TDSAsExp = (KEY, VAL, stateKey) => {
        let storeVal = VAL;
        let found = false;

        DocForm_Json?.forEach((each) => {
            if (found) return;
            each.children?.forEach((each2) => {
                if (found) return;
                each2.children?.forEach((each3) => {
                    if (found) return;
                    if (!each3.children && each3.render === "false" && each3.serviceKey === KEY) {
                        if (stateKey === "select" || !each3.val) {
                            changeValByserviceID(each3.serviceID, "serviceID", "val", storeVal);
                        } else if (each3.val) {
                            changeValByserviceID(each3.serviceID, "serviceID", "val", "");
                            storeVal = "";
                        }

                        setTokenState(prev => ({
                            ...prev,
                            [stateKey]: storeVal
                        }));
                        found = true;
                    }
                });
            });
        });
    };

    useEffect(() => {
        dynamoOption_fn()
    }, [dynamoOption_fn])

    useEffect(() => {
        HeaderJson.forEach((item, index) => {
            if (
                item.render === "true" &&
                (item.type === "select" || item.type === "search&select") &&
                item.options?.length === 1
            ) {
                const firstOptionValue = item.options[0].value;
                const currentVal = String(item.val || "").trim().toLowerCase();

                // Auto-select if value is missing, "select", or "select option"
                if (!item.val || currentVal === "select" || currentVal === "select option") {
                    changeValByserviceID(item.serviceID, "serviceID", "val", firstOptionValue);
                    onChangeOperation(item, firstOptionValue, index, "header", changeValByserviceID);

                    // Clear validation error if any
                    setHeaderValidationError(prev => {
                        const newState = { ...prev };
                        delete newState[item.serviceID];
                        return newState;
                    });
                }
            }
        });
    }, [HeaderJson, changeValByserviceID, onChangeOperation]);

    return (<>{showpopup ? (
        <ValidatePopUp
            show={showpopup}
            message={handleExtractionReview(popupMessage)}
            handleClose={() => setShowpopup(false)}
        />
    ) : null}

        {askReason?.enable && (
            <Popup
                noClose={true}
                zIndex={3000}
                content={
                    <Stack spacing={2} sx={{ minWidth: 400 }}>
                        <Typography variant="h6" sx={{ fontSize: '1rem' }}>
                            Reason for Action
                        </Typography>
                        <TextField
                            multiline
                            minRows={3}
                            size="small"
                            value={askReason.val || ""}
                            onChange={(e) => {
                                const val = e.target.value;
                                setAskReason(prev => ({ ...prev, val }));
                            }}
                        />
                        <Stack direction="row" spacing={2} justifyContent="flex-end">
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={() => {
                                    setAskReason(null);
                                }}
                                sx={{ textTransform: 'none' }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="success"
                                disabled={!askReason.val}
                                onClick={(e) => {
                                    onSubmit_Document?.(e, "Reject & Activate", askReason?.val);
                                    setAskReason(null);
                                }}
                                sx={{ textTransform: 'none' }}
                            >
                                Submit
                            </Button>
                        </Stack>
                    </Stack>
                }
            />
        )}

        <Dialog open={openAuditLog} onClose={() => setOpenAuditLog(false)} maxWidth="md" fullWidth>
            <DialogTitle sx={{ m: 0, p: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <History color="primary" />
                <Typography variant="h6" fontWeight="bold">Audit Log</Typography>
            </DialogTitle>
            <Divider />

            <Box sx={{ p: 2, bgcolor: '#f8fafc', display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                <Autocomplete
                    options={uniqueAuditFields}
                    value={auditFilterField}
                    onChange={(e, newValue) => setAuditFilterField(newValue)}
                    renderInput={(params) => <TextField {...params} label="Field" size="small" variant="outlined" />}
                    sx={{ width: { xs: '100%', sm: 250 }, bgcolor: 'background.paper' }}
                />
                <TextField
                    type="date"
                    label="Date"
                    size="small"
                    value={auditFilterDate}
                    onChange={(e) => setAuditFilterDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    sx={{ width: { xs: '100%', sm: 200 }, bgcolor: 'background.paper' }}
                />
                <TextField
                    type="time"
                    label="Time"
                    size="small"
                    value={auditFilterTime}
                    onChange={(e) => setAuditFilterTime(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    sx={{ width: { xs: '100%', sm: 150 }, bgcolor: 'background.paper' }}
                />
                <Button
                    variant="text"
                    color="secondary"
                    size="small"
                    onClick={() => { setAuditFilterField(null); setAuditFilterDate(""); setAuditFilterTime(""); }}
                    sx={{ textTransform: 'none', fontWeight: 600 }}
                >
                    Clear Filters
                </Button>
            </Box>
            <Divider />

            <DialogContent sx={{ p: 0 }}>
                <TableContainer sx={{ maxHeight: 440 }}>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f8fafc' }}>Field</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f8fafc' }}>Value</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f8fafc' }}>Modified By</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f8fafc' }}>Date & Time</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredAuditLogs?.length > 0 ? (
                                filteredAuditLogs.map((log, idx) => (
                                    <TableRow key={idx} hover>
                                        <TableCell sx={{ fontSize: '0.85rem' }}>{log.serviceKey}</TableCell>
                                        <TableCell>
                                            <Typography variant="body2" sx={{
                                                bgcolor: 'rgba(0,0,0,0.04)',
                                                px: 1,
                                                py: 0.5,
                                                borderRadius: 1,
                                                display: 'inline-block',
                                                wordBreak: 'break-all',
                                                fontSize: '0.85rem'
                                            }}>
                                                {log.value || <span style={{ color: '#999' }}>N/A</span>}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Stack direction="row" alignItems="center" spacing={1}>
                                                <IDIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                                                <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>{log.user}</Typography>
                                            </Stack>
                                        </TableCell>
                                        <TableCell sx={{ fontSize: '0.85rem' }}>
                                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                                                {log.DateTime}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
                                        <Typography color="text.secondary">No audit logs found</Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <Divider />
            <DialogActions sx={{ p: 1.5, bgcolor: '#f8fafc' }}>
                <Button onClick={() => setOpenAuditLog(false)} variant="contained" disableElevation size="small" sx={{ textTransform: 'none' }}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>

        <Box sx={{ flexGrow: 1 }}>
            <Card sx={{ borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.05)', border: '1px solid', borderColor: 'divider', overflow: 'visible' }}>
                <CardHeader
                    sx={{
                        p: { xs: 1.5, md: 1 },
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                        bgcolor: '#ffffff', // Pure white background
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        alignItems: { xs: 'flex-start', md: 'center' },
                        gap: { xs: 1.5, md: 0 },
                        '& .MuiCardHeader-content': {
                            width: { xs: '100%', md: 'auto' },
                            overflow: 'hidden'
                        },
                        '& .MuiCardHeader-action': {
                            m: 0,
                            alignSelf: { xs: 'flex-start', md: 'auto' },
                            width: { xs: '100%', md: 'auto' }
                        }
                    }}
                    title={
                        <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%' }}>
                            <IconButton
                                onClick={onBack}
                                size="small"
                                sx={{
                                    bgcolor: 'background.paper',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    '&:hover': { bgcolor: '#ffffff' },
                                    width: 32,
                                    height: 32,
                                    flexShrink: 0
                                }}
                            >
                                <ArrowLeftIcon sx={{ fontSize: 20 }} />
                            </IconButton>
                            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                                <Stack
                                    direction={{ xs: 'column', sm: 'row' }}
                                    alignItems={{ xs: 'flex-start', sm: 'center' }}
                                    spacing={1}
                                    sx={{ width: '100%', overflow: 'hidden' }}
                                >
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontWeight: 700,
                                            letterSpacing: '-0.01em',
                                            color: 'text.primary',
                                            maxWidth: { xs: '100%', sm: screenName == "BillExtract" ? 200 : 350 },
                                            flex: '1 1 auto',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {Get_Val_By_ServiceKey(screenName === "PurchaseOrder" ? "PO Number" : screenName === "GoodsAndServicesEntries" ? "GRN/SRN Number" : screenName === "ItemMaster" ? "Item ID" : screenName === "VendorMaster" ? "Vendor ID" : screenName === "OrganizationMaster" ? "Organization ID" : screenName === "BillExtract" ? "Bill Number" : '', DocForm_Json) || screenName || 'Untitled Document'}
                                    </Typography>

                                    <Stack
                                        direction="column"
                                        alignItems={{ xs: 'flex-start', sm: 'center' }}
                                        spacing={0.5}
                                        sx={{ width: { xs: '100%', sm: 'auto' }, flex: '0 1 200px' }}
                                    >
                                        <LinearProgress
                                            variant="determinate"
                                            value={formProgress?.percentage || 0}
                                            sx={{
                                                width: '100%',
                                                minWidth: { xs: '100%', sm: 100 },
                                                height: 4,
                                                borderRadius: 5
                                            }}
                                        />

                                        <Typography
                                            variant="caption"
                                            sx={{
                                                fontWeight: 600
                                            }}
                                        >
                                            {formProgress?.percentage || 0}% Complete
                                        </Typography>
                                    </Stack>
                                </Stack>
                            </Box>
                        </Stack>
                    }
                    action={
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, alignItems: 'center', width: '100%', pb: { xs: 0.5, md: 0 }, flexDirection: { xs: "column", lg: "column", xl: "row" } }}>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, flexShrink: 1, alignItems: 'center' }}>
                                <Paper
                                    elevation={0}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        border: '1px solid',
                                        borderColor: 'divider',
                                        borderRadius: 2,
                                        bgcolor: '#dedadaff',
                                        overflow: 'hidden'
                                    }}
                                >
                                    {(screenName !== 'ItemPreferences' && screenName !== 'VendorPreferences' && screenName !== 'CostAllocationMaster' && Get_Val_By_ServiceKey('Status', DocForm_Json) !== "Active") && (
                                        <>
                                            <Box sx={{ position: 'relative' }}>
                                                <Button
                                                    variant="text"
                                                    size="small"
                                                    endIcon={<ChevronDown sx={{ fontSize: 16 }} />}
                                                    onClick={(e) => setAutoSaveAnchorEl(e.currentTarget)}
                                                    sx={{
                                                        textTransform: 'none',
                                                        fontWeight: 600,
                                                        px: 1.5,
                                                        py: 0.75,
                                                        fontSize: '0.8rem',
                                                        color: '#3b82f6',
                                                        borderRadius: 0,
                                                        '&:hover': {
                                                            bgcolor: 'rgba(59, 130, 246, 0.08)'
                                                        }
                                                    }}
                                                >
                                                    Auto Save: {autoSaveInterval ? autoSaveInterval === '0.5' ? '30 Sec' : `${autoSaveInterval} Min` : 'Restrict'}
                                                </Button>
                                                <Menu
                                                    anchorEl={autoSaveAnchorEl}
                                                    open={openAutoSaveMenu}
                                                    onClose={() => setAutoSaveAnchorEl(null)}
                                                    disableScrollLock={true}
                                                    PaperProps={{
                                                        sx: { mt: 1, minWidth: 150, p: 0.5 }
                                                    }}
                                                >
                                                    <MenuItem onClick={() => { setAutoSaveInterval('0.5'); setAutoSaveAnchorEl(null); }}>
                                                        30 Seconds
                                                    </MenuItem>
                                                    <MenuItem onClick={() => { setAutoSaveInterval('1'); setAutoSaveAnchorEl(null); }}>
                                                        1 Minute
                                                    </MenuItem>
                                                    <MenuItem onClick={() => { setAutoSaveInterval('5'); setAutoSaveAnchorEl(null); }}>
                                                        5 Minutes
                                                    </MenuItem>
                                                    <MenuItem onClick={() => { setAutoSaveInterval(null); setAutoSaveAnchorEl(null); }}>
                                                        Restrict
                                                    </MenuItem>
                                                </Menu>
                                            </Box>
                                            <Divider orientation="vertical" flexItem />
                                        </>
                                    )}

                                    <Button
                                        variant="text"
                                        size="small"
                                        startIcon={isAuditLogLoading ? <CircularProgress size={16} sx={{ color: '#475569' }} /> : <History sx={{ fontSize: 18 }} />}
                                        onClick={() => getAuditlog()}
                                        disabled={isAuditLogLoading}
                                        sx={{
                                            textTransform: 'none',
                                            fontWeight: 600,
                                            px: 1.5,
                                            py: 0.75,
                                            fontSize: '0.8rem',
                                            color: '#475569',
                                            borderRadius: 0,
                                            '&:hover': {
                                                bgcolor: 'rgba(0,0,0,0.04)'
                                            }
                                        }}
                                    >
                                        Audit Log
                                    </Button>

                                    {screenName?.includes("BillExtract") && (
                                        <>
                                            <Divider orientation="vertical" flexItem />
                                            <Tooltip title="Extraction Review" arrow>
                                                <IconButton
                                                    size="small"
                                                    onClick={() => handleValidatePopup("Processed")}
                                                    sx={{
                                                        color: '#0288d1',
                                                        borderRadius: 0,
                                                        px: 1.5,
                                                        py: 0.75,
                                                        '&:hover': { bgcolor: 'rgba(2, 136, 209, 0.08)' }
                                                    }}
                                                >
                                                    <FileScan sx={{ fontSize: 18 }} />
                                                </IconButton>
                                            </Tooltip>
                                            <Divider orientation="vertical" flexItem />
                                            <Box sx={{ position: 'relative' }}>
                                                <Button
                                                    variant="text"
                                                    size="small"
                                                    endIcon={<ChevronDown sx={{ fontSize: 16 }} />}
                                                    onClick={(e) => setExpAnchorEl(e.currentTarget)}
                                                    sx={{
                                                        textTransform: 'none',
                                                        fontWeight: 600,
                                                        px: 1.5,
                                                        py: 0.75,
                                                        fontSize: '0.8rem',
                                                        color: '#475569',
                                                        borderRadius: 0,
                                                        '&:hover': {
                                                            bgcolor: 'rgba(0,0,0,0.04)'
                                                        }
                                                    }}
                                                >
                                                    Expenses
                                                </Button>
                                                <Menu
                                                    anchorEl={expAnchorEl}
                                                    open={Boolean(expAnchorEl)}
                                                    onClose={() => setExpAnchorEl(null)}
                                                    disableScrollLock={true}
                                                    PaperProps={{ sx: { mt: 1, minWidth: 200, p: 1 } }}
                                                >
                                                    <MenuItem sx={{ py: 0.5, '&:hover': { bgcolor: 'transparent' } }}>
                                                        <FormControlLabel
                                                            control={
                                                                <Switch
                                                                    checked={tokenState?.GSTasExp || false}
                                                                    onChange={() => TDSAsExp("GSTReference", "GSTasExp", "GSTasExp")}
                                                                    size="small"
                                                                    color="primary"
                                                                />
                                                            }
                                                            label={<Typography variant="body2" sx={{ fontWeight: 600 }}>GST as Exp</Typography>}
                                                            sx={{ m: 0, width: '100%' }}
                                                        />
                                                    </MenuItem>
                                                    <MenuItem sx={{ py: 0.5, '&:hover': { bgcolor: 'transparent' } }}>
                                                        <FormControlLabel
                                                            control={
                                                                <Switch
                                                                    checked={tokenState?.TDSasExp || false}
                                                                    onChange={() => TDSAsExp("TDSReference", "TDSasExp", "TDSasExp")}
                                                                    size="small"
                                                                    color="primary"
                                                                />
                                                            }
                                                            label={<Typography variant="body2" sx={{ fontWeight: 600 }}>TDS As Exp</Typography>}
                                                            sx={{ m: 0, width: '100%' }}
                                                        />
                                                    </MenuItem>
                                                </Menu>
                                            </Box>
                                        </>
                                    )}
                                </Paper>

                                {screenName?.includes("GoodsAndServicesEntries") && (
                                    <Paper elevation={0} sx={{ display: 'flex', alignItems: 'center', px: 1.5, py: 0.5, border: '1px solid', borderColor: 'divider', borderRadius: 2, bgcolor: '#f8fafc' }}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={tokenState?.DeductTDS || false}
                                                    onChange={() => TDSAsExp("DeductionRef", "DeductTDS", "DeductTDS")}
                                                    size="small"
                                                    color="primary"
                                                />
                                            }
                                            label={<Typography variant="body2" sx={{ fontWeight: 600 }}>Deduct TDS</Typography>}
                                            sx={{ m: 0 }}
                                        />
                                    </Paper>
                                )}
                            </Box>

                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>

                                {options?.length > 0 &&
                                    options?.map((treeNode, index) => {
                                        if (treeNode.type === "validate_button" && treeNode.render === "true") {
                                            return (
                                                <React.Fragment key={index}>
                                                    <Box sx={{ position: 'relative' }}>
                                                        <Button
                                                            disabled={treeNode.editable === "false"}
                                                            startIcon={<FileCog sx={{ fontSize: 18 }} />}
                                                            onClick={(e) => {
                                                                if (screenName !== "ItemPreferences" && screenName !== "VendorPreferences" && screenName !== 'CostAllocationMaster') {
                                                                    setValidateAnchorEl(e.currentTarget);
                                                                } else {
                                                                    setSelectedAction("Validate");
                                                                    handleValidateMenuClose();
                                                                    handleAction("Validate");
                                                                }
                                                            }}
                                                            sx={{
                                                                fontWeight: 600,
                                                                px: 1.5,
                                                                py: 0.5,
                                                                fontSize: '0.8rem',
                                                                bgcolor: '#f59e0b',
                                                                '&:hover': { bgcolor: '#d97706' }
                                                            }}
                                                        >
                                                            {selectedAction}
                                                        </Button>

                                                        <Menu
                                                            anchorEl={validateAnchorEl}
                                                            open={openValidateMenu}
                                                            onClose={handleValidateMenuClose}
                                                            disableScrollLock={true}
                                                            PaperProps={{
                                                                sx: { mt: 1, minWidth: 220 }
                                                            }}
                                                        >
                                                            <MenuItem
                                                                onClick={() => {
                                                                    setSelectedAction("Validate");
                                                                    handleValidateMenuClose();
                                                                    handleAction("Validate");
                                                                }}
                                                            >
                                                                Validate
                                                            </MenuItem>
                                                            <MenuItem
                                                                onClick={() => {
                                                                    setSelectedAction("Validate & Save");
                                                                    handleValidateMenuClose();
                                                                    handleAction("Validate & Save");
                                                                }}
                                                            >
                                                                Validate & Save
                                                            </MenuItem>
                                                            <MenuItem
                                                                onClick={() => {
                                                                    setSelectedAction("Validate & Exit");
                                                                    handleValidateMenuClose();
                                                                    handleAction("Validate & Exit");
                                                                }}
                                                            >
                                                                Validate & Exit
                                                            </MenuItem>
                                                        </Menu>
                                                    </Box>
                                                </React.Fragment>
                                            );
                                        }
                                        if (treeNode.type === "submit_button" && treeNode.render === "true") {
                                            return (
                                                <React.Fragment key={index}>
                                                    <Box sx={{ position: 'relative' }}>
                                                        <Button
                                                            disabled={treeNode.editable === "false"}
                                                            startIcon={<FileCheck2 sx={{ fontSize: 18 }} />}
                                                            onClick={(e) => setSubmitAnchorEl(e.currentTarget)}
                                                            sx={{
                                                                borderRadius: 2,
                                                                textTransform: 'none',
                                                                fontWeight: 600,
                                                                px: 1.5,
                                                                py: 0.5,
                                                                fontSize: '0.8rem',
                                                                bgcolor: '#10b981',
                                                                '&:hover': { bgcolor: '#059669' },
                                                                boxShadow: '0 4px 12px rgba(16, 185, 129, 0.2)'
                                                            }}
                                                        >
                                                            {selectedSubmitAction}
                                                        </Button>

                                                        <Menu
                                                            anchorEl={submitAnchorEl}
                                                            open={openSubmitMenu}
                                                            onClose={() => setSubmitAnchorEl(null)}
                                                            disableScrollLock={true}
                                                            PaperProps={{
                                                                sx: { mt: 1, minWidth: 220 }
                                                            }}
                                                        >
                                                            <MenuItem
                                                                onClick={(e) => {
                                                                    setSelectedSubmitAction("Activate");
                                                                    setSubmitAnchorEl(null);
                                                                    onSubmit_Document?.(e, "Activate");
                                                                }}
                                                            >
                                                                Activate
                                                            </MenuItem>
                                                            <MenuItem
                                                                onClick={(e) => {
                                                                    setSelectedSubmitAction("Approve & Activate");
                                                                    setSubmitAnchorEl(null);
                                                                    onSubmit_Document?.(e, "Approve & Activate");
                                                                }}
                                                            >
                                                                Approve & Activate
                                                            </MenuItem>
                                                            {(Get_Val_By_ServiceKey("Status", DocForm_Json) !== "Not Released") && <MenuItem
                                                                onClick={(e) => {
                                                                    setSelectedSubmitAction("Approve & Activate");
                                                                    setSubmitAnchorEl(null);
                                                                    ifReject();
                                                                }}
                                                            >
                                                                Reject & Activate
                                                            </MenuItem>}
                                                        </Menu>
                                                    </Box>
                                                </React.Fragment>
                                            );
                                        }
                                        return null;
                                    })}
                                {screenName?.includes("BillExtract") && (Get_Val_By_ServiceKey("Status", DocForm_Json) === "Not Released") && (
                                    <Button
                                        onClick={() => {
                                            console.log("executes");

                                            setConfirmationDialog(
                                                <DialougeBox
                                                    status={"warning"}
                                                    onClose={() =>
                                                        setConfirmationDialog(null)
                                                    }
                                                    message={
                                                        "Are you sure you want to do re-extraction? It will take a while."
                                                    }
                                                    operation={() => handleReExtract()}
                                                />
                                            )
                                        }}
                                        variant="contained"
                                        size="small"
                                        startIcon={<FileScan sx={{ fontSize: 18 }} />}
                                        sx={{
                                            borderRadius: 2,
                                            textTransform: 'none',
                                            fontWeight: 600,
                                            px: 1.5,
                                            py: 0.5,
                                            fontSize: '0.8rem',
                                            bgcolor: '#ef4444',
                                            '&:hover': { bgcolor: '#dc2626' },
                                            boxShadow: '0 4px 12px rgba(239, 68, 68, 0.2)'
                                        }}
                                    >
                                        Retry Extraction
                                    </Button>
                                )}

                                {/* <Box>
                                    <Button
                                        variant="outlined"
                                        endIcon={<ChevronDown sx={{ fontSize: 18 }} />}
                                        onClick={handleClickMenu}
                                        sx={{
                                            borderRadius: 2,
                                            textTransform: 'none',
                                            fontWeight: 600,
                                            color: 'text.secondary',
                                            borderColor: 'divider',
                                            px: 2,
                                            '&:hover': { bgcolor: '#ffffff', borderColor: 'text.secondary' }
                                        }}
                                    >
                                        Options
                                    </Button>
                                    <Menu
                                        anchorEl={anchorEl}
                                        open={openMenu}
                                        onClose={handleCloseMenu}
                                        disableScrollLock={true}
                                        PaperProps={{
                                            sx: { mt: 1, minWidth: 200, p: 1 }
                                        }}
                                    >
                                        {DocForm_Json?.map(({ children }, i) => {
                                            if (!children) return null
                                            return children?.map(({ children: child }, j) => {
                                                return child?.map((child2, k) => {
                                                    if (child2.type === "switch") {
                                                        return (
                                                            <Box key={`${ i } -${ j } -${ k } `} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 1, py: 0.5 }}>
                                                                <Typography variant="body2">{child2.title}</Typography>
                                                                <Switch
                                                                    size="small"
                                                                    id={child2.servicesID}
                                                                    checked={child2.val === "true"}
                                                                />
                                                            </Box>
                                                        )
                                                    }
                                                    return null;
                                                })
                                            })
                                        })}
                                    </Menu>
                                </Box> */}
                            </Box>
                        </Box>
                    }
                />
                <Divider />
                <CardContent sx={{ px: 3, py: 1 }}>
                    <Stack
                        direction="row"
                        spacing={3}
                        alignItems="flex-start"
                        sx={{
                            overflowX: 'auto',
                            pb: 0.5,
                            '&::-webkit-scrollbar': { height: 4 },
                            '&::-webkit-scrollbar-thumb': { bgcolor: 'divider', borderRadius: 4 }
                        }}
                    >
                        {HeaderJson.map((item, index) => {
                            if (item.render === "true" && item.title !== "Interim ID" && item.title !== "Upload Mode" && item.title !== "Message ID" && item.title !== "Object ID") {
                                const Icon = item.title === "Organization Name" ? BuildingIcon
                                    : item.title === "Organization ID" ? IDIcon
                                        : item.title === "Interim ID" ? TimeIcon
                                            : item.title === "Bill Number" ? BillIcon
                                                : item.title === "Status" ? StatusIcon
                                                    : item.title === "Upload Mode" ? ModeIcon
                                                        : HashIcon;

                                if (item.type === "select" || item.type === "search&select") {
                                    return (
                                        <Box key={index} sx={{ flexShrink: 0, minWidth: 180 }}>
                                            <Stack spacing={0.5}>
                                                <Stack direction="row" spacing={0.8} alignItems="center">
                                                    <Icon sx={{ fontSize: 14, color: 'text.secondary' }} />
                                                    <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.05em', fontSize: '0.65rem' }}>
                                                        {item.title}
                                                    </Typography>
                                                </Stack>
                                                <Box sx={{ position: 'relative' }}>
                                                    <Autocomplete
                                                        size="small"
                                                        options={item.options || []}
                                                        getOptionLabel={(option) => option?.label || ""}
                                                        value={item.options?.find(opt => opt.value === item.val) || null}
                                                        isOptionEqualToValue={(option, value) => option.value === value?.value}
                                                        onChange={(event, newValue) => {
                                                            const val = newValue ? newValue.value : "";
                                                            changeValByserviceID(item.serviceID, "serviceID", "val", val);
                                                            onChangeOperation(item, val, index, "header", changeValByserviceID);

                                                            if (val) {
                                                                setHeaderValidationError(prev => {
                                                                    const newState = { ...prev };
                                                                    delete newState[item.serviceID];
                                                                    return newState;
                                                                });
                                                            }
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Select"
                                                                error={!!headerValidationError[item.serviceID]}
                                                                sx={{
                                                                    '& .MuiInputBase-root': {
                                                                        fontSize: '0.7rem',
                                                                        backgroundColor: '#fff',
                                                                        borderRadius: 1,
                                                                        height: 28,
                                                                        '& .MuiInputBase-input': {
                                                                            py: 0.5,
                                                                        },
                                                                        '&:hover': { bgcolor: '#ffffff' }
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                        fullWidth
                                                    />
                                                </Box>
                                            </Stack>
                                        </Box>
                                    )
                                }
                                return (
                                    <Box key={index} sx={{ flexShrink: 0, minWidth: 140 }}>
                                        <Stack spacing={0.5}>
                                            <Stack direction="row" spacing={0.8} alignItems="center">
                                                <Icon sx={{ fontSize: 14, color: 'text.secondary' }} />
                                                {item.subtype !== "upload_show" && <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.05em', fontSize: '0.65rem' }}>
                                                    {item.title}
                                                </Typography>}
                                            </Stack>
                                            {item.subtype === "upload_show" ? (
                                                item.val ? (
                                                    <IconButton
                                                        size="small"
                                                        color="primary"
                                                        onClick={(e) => handleOpenPDF(e, item)}
                                                        sx={{
                                                            mt: 0.5,
                                                            alignSelf: 'flex-start',
                                                            bgcolor: 'rgba(25, 118, 210, 0.04)',
                                                            border: '1px solid',
                                                            borderColor: 'primary.light',
                                                            '&:hover': {
                                                                bgcolor: 'rgba(25, 118, 210, 0.12)'
                                                            }
                                                        }}
                                                        title="Open Attachment"
                                                    >
                                                        <PaperclipIcon fontSize="small" />
                                                    </IconButton>
                                                ) : (
                                                    <Typography variant="body2" sx={{
                                                        fontWeight: 600,
                                                        color: 'text.disabled',
                                                        bgcolor: '#ffffff',
                                                        py: 0.5,
                                                        px: 1.2,
                                                        borderRadius: 1.5,
                                                        border: '1px solid',
                                                        borderColor: 'divider',
                                                        fontSize: '0.75rem'
                                                    }}>
                                                        Unspecified
                                                    </Typography>
                                                )
                                            ) : (
                                                <Typography variant="body2" sx={{
                                                    fontWeight: 600,
                                                    color: item.val ? 'text.primary' : 'text.disabled',
                                                    bgcolor: '#ffffff',
                                                    py: 0.5,
                                                    px: 1.2,
                                                    borderRadius: 1.5,
                                                    border: '1px solid',
                                                    borderColor: 'divider',
                                                    fontSize: '0.75rem',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'
                                                }}>
                                                    {item.val || 'Unspecified'}
                                                </Typography>
                                            )}
                                        </Stack>
                                    </Box>
                                )
                            }
                            return null;
                        })}
                    </Stack>
                </CardContent>
            </Card >
        </Box >
    </>)
}

export default DocumentHeader